module.exports = __webpack_public_path__ + "static/media/ricardo-perez-plus.d7ba2a0c.svg";